import React from 'react';

interface ViewProps {
  width?: number;
  height?: number;
}

export const SingleView = ({ width = 66, height = 50 }: ViewProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 66 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      y="0.5"
      width="64.3333"
      height="49"
      rx="1.5"
      stroke="#333745"
      strokeDasharray="3 3"
    />
  </svg>
);
